import { render, staticRenderFns } from "./CSVBoxButton.vue?vue&type=template&id=22b51c94&scoped=true&"
import script from "./CSVBoxButton.vue?vue&type=script&lang=js&"
export * from "./CSVBoxButton.vue?vue&type=script&lang=js&"
import style0 from "./CSVBoxButton.vue?vue&type=style&index=0&id=22b51c94&scoped=true&lang=css&"
import style1 from "./CSVBoxButton.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b51c94",
  null
  
)

export default component.exports